import { isPlainObject } from './isPlainObject'

// Reads `errors.code` off an error response body (`{errors: {code}}`).
export const getErrorCode = (data: unknown): string | undefined => {
  if (!isPlainObject(data) || !isPlainObject(data.errors)) return undefined
  const { code } = data.errors
  return typeof code === 'string' ? code : undefined
}
